module.exports = __webpack_public_path__ + "media/application/images/svgs/code-b1d452f0bce4637af8682bcc861371b0.svg";